import React from 'react';
import { connect } from 'react-redux';

import Paper from 'xgimi-ui/mui/material/Paper';

import moment from 'moment';
import StoreComponent, { mapStateToProps } from '../../../../../appComponents/Store';

import s from './.module.scss';

interface Props {
  data: Record<string, any>;
  // 详情
  onDetail: (feedbackNo: string) => void;
}

/**
 * 列表项
 */
class Component extends StoreComponent<Props> {
  render(): React.ReactNode {
    return (
      <Paper
        className={s.container}
        elevation={1}
        onClick={() => this.props.onDetail(this.props.data.feedbackNo)}
      >
        <div className={s.itemFlex}>
          <div>
            <span>{`ID:${this.props.data.id}`}</span>
            <span className={s.topDivide}>|</span>
            <span>{this.props.data.ownerUserName ? this.props.data.ownerUserName : this.props.data.ownerUser}</span>
          </div>
          <div>
            {moment(this.props.data.createdAt).format('YYYY-MM-DD HH:mm')}
          </div>
        </div>
        <div className={s.itemFlex}>
          <div className={s.type}>{this.props.data.feedbackTypeAll}</div>
          <div className={s.delay}>{this.props.data?.overtime}</div>
        </div>
        <div className={s.itemTags}>
          {this.props.data.replyStatus ? <div className={s.default}>已回复</div> : <div className={s.noReply}>未回复</div> }
          {this.props.data.finaleEnd ? <div className={s.default}>已完结</div> : <div className={s.noFinish}>未完结</div>}
          {this.props.data.processStatus && this.props.data.processStatus?.split(',').map((item: string, index: number) => (
            <div className={s.processStatus} key={index}>{item}</div>
          ))}
          <div className={s.deviceName}>{this.props.data.device}</div>
        </div>
        <div className={s.content}>{this.props.data.content}</div>
      </Paper>
    );
  }
}

export default connect(mapStateToProps)(Component);
